var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header__dropdown-container-inner" },
    [
      _c(
        "div",
        { staticClass: "header__dropdown-inner-small-images-container" },
        [
          _c(
            "div",
            { staticClass: "header__dropdown-small-images-container" },
            [
              _vm.block.image_1
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-image-outer-container" },
                    [
                      _vm.block.image_1_url
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container clip-transition",
                              attrs: { href: _vm.block.image_1_url }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.block.image_1,
                                      alt: _vm.block.image_1_text
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_1_text
                                ? _c(
                                    "div",
                                    { staticClass: "header-menu-image-title" },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.block.image_1_text))
                                      ]),
                                      _c("icon", {
                                        staticClass:
                                          "menu-image-link-arrow fill-brand-primary",
                                        attrs: {
                                          name: "arrow_long_right",
                                          size: "24px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container clip-transition"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.block.image_1,
                                      alt: _vm.block.image_1_text
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_1_text
                                ? _c(
                                    "p",
                                    { staticClass: "header-menu-image-title" },
                                    [_vm._v(_vm._s(_vm.block.image_1_text))]
                                  )
                                : _vm._e()
                            ]
                          )
                    ]
                  )
                : _vm._e(),
              _vm.block.image_2
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-image-outer-container" },
                    [
                      _vm.block.image_2_url
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container clip-transition",
                              attrs: { href: _vm.block.image_2_url }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.block.image_2,
                                      alt: _vm.block.image_2_text
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_2_text
                                ? _c(
                                    "div",
                                    { staticClass: "header-menu-image-title" },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.block.image_2_text))
                                      ]),
                                      _c("icon", {
                                        staticClass:
                                          "menu-image-link-arrow fill-brand-primary",
                                        attrs: {
                                          name: "arrow_long_right",
                                          size: "24px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container clip-transition"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.block.image_2,
                                      alt: _vm.block.image_2_text
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_2_text
                                ? _c(
                                    "p",
                                    { staticClass: "header-menu-image-title" },
                                    [_vm._v(_vm._s(_vm.block.image_2_text))]
                                  )
                                : _vm._e()
                            ]
                          )
                    ]
                  )
                : _vm._e(),
              _vm.block.image_3
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-image-outer-container" },
                    [
                      _vm.block.image_3_url
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container clip-transition",
                              attrs: { href: _vm.block.image_3_url }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.block.image_3,
                                      alt: _vm.block.image_3_text
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_3_text
                                ? _c(
                                    "div",
                                    { staticClass: "header-menu-image-title" },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.block.image_3_text))
                                      ]),
                                      _c("icon", {
                                        staticClass:
                                          "menu-image-link-arrow fill-brand-primary",
                                        attrs: {
                                          name: "arrow_long_right",
                                          size: "24px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container clip-transition"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.block.image_3,
                                      alt: _vm.block.image_3_text
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_3_text
                                ? _c(
                                    "p",
                                    { staticClass: "header-menu-image-title" },
                                    [_vm._v(_vm._s(_vm.block.image_3_text))]
                                  )
                                : _vm._e()
                            ]
                          )
                    ]
                  )
                : _vm._e(),
              _vm.block.image_4
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-image-outer-container" },
                    [
                      _vm.block.image_4_url
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container clip-transition",
                              attrs: { href: _vm.block.image_4_url }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.block.image_4,
                                      alt: _vm.block.image_4_text
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_4_text
                                ? _c(
                                    "div",
                                    { staticClass: "header-menu-image-title" },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.block.image_4_text))
                                      ]),
                                      _c("icon", {
                                        staticClass:
                                          "menu-image-link-arrow fill-brand-primary",
                                        attrs: {
                                          name: "arrow_long_right",
                                          size: "24px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container clip-transition"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.block.image_4,
                                      alt: _vm.block.image_4_text
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_4_text
                                ? _c(
                                    "p",
                                    { staticClass: "header-menu-image-title" },
                                    [_vm._v(_vm._s(_vm.block.image_4_text))]
                                  )
                                : _vm._e()
                            ]
                          )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm.block.url
        ? _c(
            "v-link",
            {
              staticClass: "header__menu-main-inner-link",
              attrs: { secondary: "", href: _vm.block.url }
            },
            [_vm._v("  Shop All")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }